import { Box, IconButton, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { useCallback, useMemo } from "react";
import { useGetMeQuery } from "src/api/services/api";
import Spinner from "src/components/Spinner";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import StartRoundedIcon from "@mui/icons-material/StartRounded";
import { useNavigate } from "react-router-dom";
import { Paths } from "src/constants/paths";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";

const Home = () => {
  const { data: profile, isLoading } = useGetMeQuery();

  const navigate = useNavigate();
  const provider = useClinician((clinician) =>
    clinician.roles.some((r) => r.name.includes("Provider")),
  );
  const coordinator = useClinician((clinician) =>
    clinician.roles.some((r) => r.name.includes("Coordinator")),
  );

  const navigateToProviderTaskQueue = useCallback(
    () => navigate(Paths.PROVIDER_TASK_QUEUE),
    [navigate],
  );

  const navigateToCoordinatorTaskQueue = useCallback(
    () => navigate(Paths.COORDINATOR_TASK_QUEUE),
    [navigate],
  );

  const providerName = useMemo(() => {
    return `${profile?.first_name} ${profile?.last_name}`;
  }, [profile?.first_name, profile?.last_name]);

  const currentMonth = useMemo(() => {
    return format(new Date(), "MMMM");
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Stack>
      <Typography variant="h4">Hi {providerName}</Typography>
      <Stack direction="row" mt={4} gap={3}>
        <Stack
          gap={4}
          p={2.5}
          sx={{ backgroundColor: "#00B5B8", borderRadius: "6px" }}
          maxWidth="600px"
          width="100%"
          height="fit-content"
        >
          <Box display="flex" justifyContent="space-between">
            <Typography color="#ffffff" variant="h6">
              {providerName}
            </Typography>
            <Typography color="#ffffff" variant="h6">
              {currentMonth}
            </Typography>
          </Box>
          {/* <Box display="flex" justifyContent="space-between">
            <Stack>
              <Typography color="#ffffff">Total tasks</Typography>
              <Typography color="#ffffff">X.XX</Typography>
            </Stack>
            <Stack>
              <Typography color="#ffffff">Total points</Typography>
              <Typography color="#ffffff">X.XX</Typography>
            </Stack>
            <Stack>
              <Typography color="#ffffff">Efficiency</Typography>
              <Typography color="#ffffff">X.XX</Typography>
            </Stack>
          </Box> */}
        </Stack>
        <Stack gap={3} maxWidth="600px" width="100%">
          {provider ? (
            <Stack
              p={2.5}
              sx={{ borderRadius: "6px", border: "1px solid #E5E5E5" }}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack gap={1}>
                <Typography variant="h6">Provider Task Queue</Typography>
                <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                  <ErrorOutlineOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#FF8175" }}
                  />
                  <Typography>Many tasks available</Typography>
                </Box>
              </Stack>
              <IconButton onClick={navigateToProviderTaskQueue}>
                <StartRoundedIcon
                  sx={{ color: "#00B5B8", fontSize: "4rem", cursor: "pointer" }}
                />
              </IconButton>
            </Stack>
          ) : null}
          {coordinator ? (
            <Stack
              p={2.5}
              sx={{ borderRadius: "6px", border: "1px solid #E5E5E5" }}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack gap={1}>
                <Typography variant="h6">
                  Health Navigator Task Queue
                </Typography>
                <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                  <ErrorOutlineOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#FF8175" }}
                  />
                  <Typography>Many tasks available</Typography>
                </Box>
              </Stack>
              <IconButton onClick={navigateToCoordinatorTaskQueue}>
                <StartRoundedIcon
                  sx={{ color: "#00B5B8", fontSize: "4rem", cursor: "pointer" }}
                />
              </IconButton>
            </Stack>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Home;
